import differenceBy from 'lodash/differenceBy';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { UserFieldControlMessageMeta } from 'api/conversations';
import { User } from 'api/models';
import { fullName } from 'utils/full-name';

export const UserControlMessage: FC<{
  meta: UserFieldControlMessageMeta;
  rootKey: string;
  userName: string;
}> = ({ meta, rootKey, userName }) => {
  const intl = useIntl();
  let keyForString = rootKey;
  let diff: User[] = [];

  if (meta.fieldType === 'MULTI_SELECT') {
    const { oldListObject = [], newListObject = [] } = meta;

    if (oldListObject.length < newListObject.length) {
      keyForString += '.MULTI_SELECT.ADDED';
      diff = differenceBy(newListObject, oldListObject, 'userId');
    } else {
      keyForString += '.MULTI_SELECT.REMOVED';
      diff = differenceBy(oldListObject, newListObject, 'userId');
    }

    return (
      <FormattedMessage
        id={keyForString}
        values={{
          changedByUserName: userName,
          label: meta.fieldLabel || meta.fieldName,
          diff: intl.formatList(diff.map((d) => fullName(d))),
        }}
      />
    );
  }

  if (!meta.oldValue) {
    keyForString += '.ADDED';
  } else if (!meta.newValue) {
    keyForString += '.REMOVED';
  } else {
    keyForString += '.UPDATED';
  }

  return (
    <FormattedMessage
      id={keyForString}
      values={{
        changedByUserName: userName,
        label: meta.fieldLabel || meta.fieldName,
        from: meta.oldValue ? fullName(meta.oldValue) : '',
        to: meta.newValue ? fullName(meta.newValue) : '',
      }}
    />
  );
};
